import { MultiChannelOrderItemsFindResponseDto } from '../../../../types/api/multi-channels';
import { MultiChannelOrderListResponse } from '../../../../types/multiChannel/orderManagement';
import { CANCEL_DISPOSER_TEXT, ORDER_STATUS_TEXT } from '../../../../constants/service/app/multiChannelConstants';
import { formatDate } from '../../../../lib/utils/date/formatDate';
import { DATE_FORMAT } from '../../../../constants/service/common/dateConstants';

export const convertMultiChannelOrderListResponse = (
  data: MultiChannelOrderItemsFindResponseDto,
): MultiChannelOrderListResponse => ({
  totalCount: data.totalCount,
  orderList: data.multiChannelOrderItems.map((item) => ({
    id: item.id,
    externalOrderId: item.externalOrderId,
    brandId: item.brand.id,
    brandName: item.brand.name,
    status: item.status,
    statusText: ORDER_STATUS_TEXT[item.status],
    multiChannelName: item.multiChannel.name,
    deliveryEnterpriseName: item.delivery?.deliveryEnterprise?.name,
    invoiceNumber: item.delivery?.invoiceNumber,
    deliveryId: item.delivery?.id,
    productId: item.productId,
    productOptionId: item.productOptionId,
    productName: item.productName,
    productOptionName: item.productOptionName,
    productBarcode: item.productBarcode,
    productOptionBarcode: item.productOptionBarcode,
    productNumber: item.productNumber,
    productOptionNumber: item.productOptionNumber,
    createDate: formatDate(item.createDate, DATE_FORMAT.YMD_HM_DOT_FORMAT),
    quantity: item.quantity,
    message: item.message,
    cancelledDate: formatDate(item.cancel?.cancelledDate, DATE_FORMAT.YMD_HM_DOT_FORMAT),
    cancelDisposer: item.cancel?.disposer ? CANCEL_DISPOSER_TEXT[item.cancel.disposer] : undefined,
    recipient: item.delivery?.recipient,
    recipientPhone: item.delivery?.cellPhone,
    recipientAddress: item.delivery?.mainAddress,
    recipientDetailAddress: item.delivery?.detailAddress,
    recipientZipcode: item.delivery?.postCode,
  })),
});
